export default function ToolHeader(){
	return (
		<header>
			<div className="wp-block-cover">
				<div className="wp-block-cover__inner-container">
					<div className="wp-block-group row">
						<div className="wp-block-group margin-lg">
							<h1 className="has-text-align-left has-tree-green-color has-text-color">
								{window?.wpObject?.title != null ? window.wpObject.title : "Ingen titel satt"}
							</h1>
							{
								window?.wpObject?.subtitle != null &&
								<h2 className="has-text-align-left has-tree-green-color has-text-color">
									{window.wpObject.subtitle}
								</h2>
							}
						</div>
					</div>
				</div>
			</div>
		</header>
	);
}
